import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import ScrollProgress from '@/components/ui/ScrollProgress';
import { useAppStore } from '../store/appStore';
import { useUIStore } from '../store/uiStore';
import PreferencesModal from '@/features/preferences/PreferencesModal';

export default function AppLayout() {
  const location = useLocation();
  const { isSidebarExpanded } = useAppStore();
  const headerVisible = useUIStore((state: any) => state.headerVisible);

  const title = (() => {
    if (location.pathname === '/chat') return 'AI Chat';
    if (location.pathname === '/chat/legacy') return 'AI Assistant';
    if (location.pathname === '/projects') return 'Projects';
    if (location.pathname === '/agents') return 'Agents';
    if (location.pathname === '/chat_test_runner') return 'Chat Test Runner';
    if (location.pathname === '/system-monitor/ws-log') return 'WebSocket Logs';
    if (location.pathname === '/system-monitor') return 'WeBelieve System Monitor';
    return '';
  })();

  // Hide global header based on UI store (controlled by EdgeDocsEditorPage)
  const hideHeader = !headerVisible;

  // Check if we're on an EdgeDocs editor page or WeBeMail client (needs full-bleed layout)
  const isEdgeDocsEditor = location.pathname.includes('/editor') || location.pathname.includes('/dms/editor');
  const isWeBeMailClient = location.pathname === '/email' || location.pathname.startsWith('/email/');
  const isCalendarPage = location.pathname === '/calendar' || location.pathname.startsWith('/calendar/');
  const isLexRuntimeWorkspace = location.pathname === '/chat' || location.pathname.startsWith('/chat/');

  return (
    <div className="flex h-screen bg-[var(--brand-surface-app)] text-[var(--brand-text-primary)]">
      <Sidebar />
      <div className="relative z-20 flex-1 flex flex-col min-w-0">
        <ScrollProgress />
        {!hideHeader && !isWeBeMailClient && (
          <Header currentViewTitle={title} isSidebarCollapsed={!isSidebarExpanded} />
        )}
        <PreferencesModal />
        <main
          className={`flex-1 min-h-0 lex-page-content transition-colors duration-300 ${
            isEdgeDocsEditor || isWeBeMailClient || isCalendarPage || isLexRuntimeWorkspace
              ? 'overflow-hidden h-full' // Full height, no scroll - let child handle it
              : `overflow-y-auto p-4 sm:p-6 md:p-8 ${hideHeader ? '' : 'pt-16'}`
          }`}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
